import { useSyncExternalStore } from 'react'

/**
 * Whether the browser thinks it has a connection. `navigator.onLine` only reports the link layer,
 * not whether the API answers, which is exactly what the offline banner claims: "you are offline",
 * not "the server is down". A failed call says the rest through {@link ../lib/api.ApiError}.
 */
export function useIsOnline(): boolean {
  return useSyncExternalStore(subscribe, () => navigator.onLine, alwaysOnlineOnTheServer)
}

function subscribe(onChange: () => void): () => void {
  addEventListener('online', onChange)
  addEventListener('offline', onChange)
  return () => {
    removeEventListener('online', onChange)
    removeEventListener('offline', onChange)
  }
}

function alwaysOnlineOnTheServer(): boolean {
  return true
}
